export default "__VITE_ASSET__y3nPGFWb__"